import React from 'react';
import styled from 'styled-components';
import Theme from '../../Theme';
import * as AppActions from '../../AppActions';
import DataJson from '../../../data.json';
import RjsfAddressField from '../../Components/RjsfAddressField';
import AdminAvatarWidget from '../../Generators/AdminResource/AdminAvatarWidget';
import GenericForm from 'rev.sdk.js/Generic/Form';
import {validate} from '../../Utils/FormUtil';
import {useOutlet} from 'reconnect.js';
import * as Ant from 'antd';
import AdminDateWidget from '../../Generators/AdminResource/AdminDateWidget';
const spec = require('../../../content/admin/user.json').formSpec;

const rjsfProps = {
  widgets: {
    'rev-avatar-widget': AdminAvatarWidget,
    'admin-date-widget': AdminDateWidget,
  },
  fields: {
    'rev-address-field': RjsfAddressField,
  },
};

export default function EditProfileForm(props) {
  const {onSuccess = () => {}} = props;
  const [user] = useOutlet('user');
  const [record, setRecord] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [errorList, setErrorList] = React.useState([]);
  const disabledLabel = loading ? '載入中' : '';

  const {schema, uiSchema} = React.useMemo(() => {
    let schema = {...spec.schema};
    let uiSchema = {...spec.uiSchema};

    const excludeFields = [
      'member_id',
      'category',
      'status',
      'in_date',
      'out_date',
      'out_reason',
      'other_reason',
      'note',
      'send',
      'rev-line-0',
      'rev-line-1',
      'rev-line-2',
      'rev-line-3',
    ];
    for (let f of excludeFields) {
      delete schema.properties[f];
    }
    // schema.required = schema.required.filter(
    //   (x) => !['name', 'id_card_number'].includes(x),
    // );
    schema.properties.id_card_number.readOnly = true;
    schema.properties.name.readOnly = true;

    uiSchema.avatar = {
      'ui:widget': 'rev-avatar-widget',
      'ui:options': {label: false},
    };

    return {schema, uiSchema};
  }, []);

  React.useEffect(() => {
    if (user) {
      // initialize
      setRecord({...user.data});
      // formProps.onChange({formData: {...user.data}});
    }
  }, [user]);

  React.useEffect(() => {
    if (typeof window !== 'undefined' && errorList.length > 0) {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, [errorList.length]);

  const renderCustomSubmitButton = React.useCallback(
    ({values: formData}) => {
      return (
        <Ant.Space>
          <Ant.Button
            type="primary"
            disabled={disabledLabel}
            className="tda-form-button"
            onClick={async () => {
              setLoading(true);
              setErrorList([]);
              try {
                // validation
                let errorList = [];

                errorList = errorList.concat(validate(schema, formData));

                if (
                  !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                    formData.email,
                  )
                ) {
                  errorList.push('信件格式錯誤');
                }
                if (!/^09[0-9]{8}$/.test(formData.phone)) {
                  errorList.push('行動電話格式錯誤');
                }
                if (!/^[A-Z][12]\d{8}$/.test(formData.id_card_number)) {
                  errorList.push('身分證字號格式錯誤');
                }

                if (errorList.length > 0) {
                  setErrorList(errorList);
                  setLoading(false);
                  return;
                }

                // const certS3Key = `private_uploads/${UploadUtil.getRandomKeyWithDatePrefix()}`;
                // await UploadUtil.uploadFile(cert, certS3Key, {
                //   acl: 'private',
                //   unique_key: false,
                // });

                const resp = await AppActions.tdaUpdateUserProfile(formData);

                onSuccess(resp);
              } catch (ex) {
                console.warn('REV_DBG', ex);

                setErrorList(['發生錯誤']);
              }
              setLoading(false);
            }}>
            {disabledLabel || '更新個人資料'}
          </Ant.Button>
        </Ant.Space>
      );
    },
    [disabledLabel],
  );

  return (
    <div>
      {record && (
        <GenericForm
          schema={schema}
          uiSchema={uiSchema}
          instance={record}
          onSubmit={() => {
            AppActions.setLoading(false);
          }}
          onChange={false}
          rjsfProps={rjsfProps}
          renderCustomSubmitButton={renderCustomSubmitButton}
        />
      )}

      {errorList.length > 0 && (
        <div className="tda-form-error-list">
          <h4>欄位錯誤</h4>
          <ul>
            {errorList.map((it, idx) => {
              return <li key={idx}>{it}</li>;
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
